module.exports = __webpack_public_path__ + "static/media/cntrg.49b56041.data";